import { StarIcon } from 'lucide-react'

const maximumRating = 5

/** Оценка звёздами: целые звёзды закрашены, остальные приглушены. */
export const Stars = ({ value, className }: { value: number; className?: string }) => (
  <span className={`flex items-center gap-0.5 ${className ?? ''}`} aria-label={`Оценка ${value} из ${maximumRating}`}>
    {Array.from({ length: maximumRating }, (_, index) => (
      <StarIcon
        key={index}
        aria-hidden="true"
        // Размер звезды привязан к размеру шрифта рядом: в списке она мелкая, в шапке карточки крупная.
        className={`size-[1.15em] ${index < Math.round(value) ? 'fill-warning text-warning' : 'text-muted-foreground/40'}`}
      />
    ))}
  </span>
)
